function checkDeviceRelay(device_uid, relay, request_type) {
    const url = "/device/" + device_uid + "/relay/";
    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "relay": relay,
            "command": $('#id_command_' + relay).val(),
            "delay": $('#id_delay_' + relay).val(),
            "request_type": request_type
        },
        success: function (response) {
            const title = response.title;
            const message = response.message;
            $("#modal-header").text(title).attr("style", "color: green; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: green; text-align: center;");
        },
        error: function (response) {
            const title = response.responseJSON.title;
            const message = response.responseJSON.message;
            $("#modal-header").text(title).attr("style", "color: red; text-align: center;");
            $("#modal-command").text(message).attr("style", "color: red; text-align: center;");
            $('#message').modal("show");
        }
    })
    $('#message').modal("show");
    setTimeout(function () {
        $('#message').modal("hide");
        location.reload();
    }, 2000);
}

function lockUnlockDelayField(commandSelect) {
    const opt = commandSelect.querySelector('option:checked')
    const command = opt.value
    const delayInput = commandSelect.parentElement.parentElement.querySelector('input[name="delay"]')
    delayInput.readOnly = !(command === 'circuit/restart')
    delayInput.value = 1
}

function checkAndChangeValueInDelayField(delayInput, isEmptyAllow = false) {
    if (isEmptyAllow) {
        if (delayInput.value === '') {
            return
        }
    }
    delayInput.value = clamp(delayInput.value, 1, 250)
}